<template>
  <div class="container">
    <div class="p-mb-4 small-data">
      <div class="p-d-flex" v-if="serviceCall.ReportTypeDesc">
        <span>{{ __("Call type") }}:</span>
        <span class="service-call-data">{{ serviceCall.ReportTypeDesc }}</span>
      </div>
      <div class="p-d-flex" v-if="serviceCall.Service">
        <span>{{ __("Group") }}:</span>
        <span class="service-call-data">{{ serviceCall.GroupName }}</span>
      </div>
      <div class="p-d-flex" v-if="serviceCall.Company">
        <span>{{ __("Supplier") }}:</span>
        <span class="service-call-data">{{ serviceCall.Company }}</span>
      </div>
      <div class="p-d-flex" v-if="serviceCall.ReportByPriority">
        <span>{{ __("Priority") }}:</span>
        <span class="service-call-data">{{
          serviceCall.ReportByPriority
        }}</span>
      </div>
      <div class="p-d-flex" v-if="serviceCall.WorkerName">
        <span>{{ __("User") }}:</span>
        <span class="service-call-data">{{ serviceCall.WorkerName }}</span>
      </div>
    </div>
    <div class="p-d-flex" v-if="serviceCall.aaaFinal">
      <span>{{ __("Unit") }}:</span>
      <span class="service-call-data">{{ serviceCall.aaaFinal }}</span>
    </div>
    <div class="p-d-flex p-mt-2" v-if="serviceCall.Desc">
      <span>{{ __("Remarks") }}:</span>
      <span class="service-call-data">{{ serviceCall.Desc }}</span>
    </div>
    <div class="p-d-flex p-mt-4 p-jc-between" v-if="serviceCallLocal?.ReportName">
      <div class="p-d-flex">
        <span>{{ __("Reporting Details") }}:</span>
        <span class="service-call-data">{{ serviceCall.ReportName }}</span>
      </div>
      <i-contacts-group
        :data="{
          mail: serviceCall.ReturnEmail,
          phone: serviceCall.ReturnPhone,
          whatsapp: serviceCall.ReturnPhone,
        }"
        :showArrowBtn="true"
        :contact="serviceCallLocal"
        @showContact="showContact"
      />
    </div>
    <p-transition-expand>
      <div v-if="serviceCallLocal?.Expanded" class="p-d-flex p-jc-between">
        <div class="p-d-flex p-flex-column p-mt-2">
          <label>{{ __("Mobile") }}:</label>
          <span class="service-call-data">{{
            __(serviceCall.ReturnPhone)
          }}</span>
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <label>{{ __("Email") }}:</label>
          <span class="service-call-data">{{
            __(serviceCall.ReturnEmail)
          }}</span>
        </div>
      </div>
    </p-transition-expand>
  </div>
  <div class="p-d-flex p-jc-end p-mt-2" style="gap: 10px;">
    <p-vue-button
      icon="pi pi-trash"
      class="p-button-rounded p-button-danger p-button-outlined"
      @click="confirmDelete"
      v-if="allowDelete != 0"
    />
  </div>
</template>

<script>
import {
  callProc,
  apiParam,
  apiPType,
  getGlobalApi,
} from "@/services/APointAPI";
import { errorReceived, showSuccessOrFailedModal } from "@/services/apointUtil";
import { __ } from "@/plugins/i18n/";
import PTransitionExpand from "@/components/partials/p-transition-expand";

export default {
  props: {
    serviceCall: Object,
  },
  emits: ["DeleteServiceCall"],
  components: {
    PTransitionExpand,
  },
  data() {
    return {
      allowDelete: 0,
      serviceCallLocal: null,
    };
  },
  mounted() {
    this.getAllowDelete();
    this.serviceCallLocal = this.serviceCall;
    this.serviceCallLocal.Expanded = false;
    // console.log(this.serviceCallLocal);
  },
  methods: {
    getAllowDelete() {
      getGlobalApi("AllowProblemsDeleteThroughApp")
        .then((result) => {
          this.allowDelete = result;
        })
        .catch(() => {
          errorReceived("AllowProblemsDeleteThroughApp");
        });
    },
    confirmDelete(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message: __("Are you sure you want to delete this service call?"),
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.deleteProblem();
        },
        reject: () => {},
      });
    },
    deleteProblem() {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("PID", this.PID, apiPType.Int)];
      callProc("WorkerApp_DeleteProblem", procParams)
        .then((result) => {
          result = JSON.parse(result);
          if (result.Table[0].status == 0) {
            showSuccessOrFailedModal(
              __("The service call was deleted successfully")
            );
            setTimeout(() => {
              this.$emit("DeleteServiceCall", this.PID);
            }, 1000);
          } else {
            showSuccessOrFailedModal(__(result.Table[0].desc), false);
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_DeleteProblem");
        });
    },
    showContact() {
      this.serviceCallLocal.Expanded = !this.serviceCallLocal.Expanded;
      // console.log(this.serviceCall);
    },
  },
  computed: {
    PID() {
      return this.serviceCall.PID;
    },
  },
};
</script>

<style scoped>
.small-data {
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 10px;
}

.service-call-data {
  color: var(--color-accent);
}

.p-d-flex {
  gap: 10px;
}
</style>
